module.exports = __webpack_public_path__ + "static/media/slider-previous.7f1d0344.svg";